import createVueApp from '@phoenix/createVueApp';
import { PhxGoogleMap, PhxGoogleMapMarker, PhxGoogleMapMarkerCluster } from '@phx-styleguides/jlc';

const app = createVueApp();
app.component('PhxGoogleMap', PhxGoogleMap);
app.component('PhxGoogleMapMarker', PhxGoogleMapMarker);
app.component('PhxGoogleMapMarkerCluster', PhxGoogleMapMarkerCluster);
app.mount('#phoenix-google-map');
